module.exports = __webpack_public_path__ + "fonts/SteelfishEb-Italic.9b942a37.woff2";